import { useQuery } from '@tanstack/react-query';

import { createQuizResultsStore } from '../useQuizResultStore';

import { sdk } from '@/services';

const QuizResultsService = sdk.getService('QuizResultService');
const useStore = createQuizResultsStore({ title: 'asc' });

export const useMyQuizResultsByCourseSections = (courseId: string) => {
  const { sort, setSort, filters, setFilters } = useStore();

  const queryKey = ['quiz-results', 'by-course-sections', courseId, sort, filters];
  const { data, isLoading } = useQuery({
    queryKey,
    queryFn: () => QuizResultsService.findUserQuizStatsByCourseSections(courseId, filters, sort)
  });

  return {
    quizResultsByCourseSections: data?.quizzesWithSection ?? [],
    quizResultsByCourseWithoutSections: data?.quizzesWithoutSection ?? undefined,
    isLoading,
    sort,
    setSort,
    filters,
    setFilters
  };
};
